<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="isAdmin && isPromoteur"
      :has-fullscreen="true">
      <router-link
        v-if="isAdmin && isPromoteur"
        :to="{name: 'ProgramCreate'}"
        slot="dropdown-content"
        class="dropdown-item is-padding-left-large has-text-weight-normal"
        style="min-width:323px; min-height: 49px; display: flex; align-items: center;"
        id="programCreateButton">
        <!--<span class="icon is-medium"><i class="fas fa-plus-circle"></i></span>-->
        <span style="color: #363636;">Créer fiche programme</span>
      </router-link>
      <router-link
        v-if="isAdmin && isPromoteur"
        :to="{name: 'ProgramCreate', params: {isAmenagement: true}}"
        slot="dropdown-content"
        class="dropdown-item is-padding-left-large has-text-weight-normal"
        style="min-width:323px; min-height: 49px; display: flex; align-items: center;"
        id="programCreateButton">
        <!--<span class="icon is-medium"><i class="fas fa-plus-circle"></i></span>-->
        <span style="color: #363636;">Créer fiche lotissement</span>
      </router-link>
      <div
        class="column"
        slot="page-header">
        <div class="page-header-breadcrumb">
          <h1
            v-if="!hideTopButtom"
            class="button is-primary is-radiusless page-header-breadcrumb-item column is-narrow has-text-white is-uppercase"
            :class="mainLoading ? 'is-loading' : ''"
            style="padding: 14px 0; min-width: 250px;">
            <span class="is-size-5 is-margin-left-xsmall is-margin-right-xsmall">{{ `${totalPrograms} programme(s) / ${totalLots} lot(s)` }}</span>
          </h1>
          <h1
            class="is-padding-left page-header-breadcrumb-item"
            v-else>
            <span class="is-uppercase">{{ $route.name === 'LotList' ? 'Lots' : 'Programmes' }}</span>
          </h1>
        </div>
      </div>
      <!-- <div
        class="column is-paddingless"
        slot="before-actions"
        v-if="isAdmin && isPromoteur && multiselection && selectedItems.length">
        <a
          @click="ExportGenerator"
          class="page-header-btn is-small is-success">
          <span class="icon"><i class="fas fa-file-excel"></i></span>
          <span>Exporter {{ $route.name === 'LotList' ? 'Lots' : 'Programmes' }}</span>
        </a>
      </div> -->
      <!-- <div
        class="column is-paddingless is-narrow"
        slot="before-actions"
        v-if="isAdmin && isPromoteur && multiselection && selectedItems.length">
        <a
          @click="$route.name === 'LotList' ? changeLotsStatusSelection() : changeProgramsStatusSelection()"
          class="page-header-btn is-small">
          <span class="icon"><i class="fas fa-exchange-alt"></i></span>
          <span>Changer statut sélection</span>
        </a>
      </div> -->
      <div
        class="column is-paddingless is-narrow"
        slot="before-actions"
        v-if="isAdmin && isPromoteur && ($route.name === 'ProgramCardList' || $route.name === 'ProgramList')">
        <a
          @click="triggerSpoImport"
          class="page-header-btn is-small"
          :class="{'is-loading': importLoading}">
          <span class="icon"><i class="fas fa-download"></i></span>
          <span>Importer stock SPO</span>
        </a>
      </div>
    </page-nav-bar>
    <page-content
      :has-sticky-col-left="true"
      :has-left-col-collapse="true"
      :opened-col="openedCol"
      :has-padd-right-normal="true">
      <template slot="left-col-small">
        <col-collapse-filter
          :has-filter="hasFilter"
          @opened="openCollapseFilter"
          :more-filters-label="'criteriaTabEnabled'"
          @resetFilters="resetFilters()">
          <div
            v-if="openedModal"
            class="outside_multiselectmodal"
            @click="openedModal = ''"></div>
          <div id="filter-info">
            <div
              class="button is-primary is-small column has-text-white is-radiusless has-text-centered has-text-weight-semibold"
              :class="mainLoading ? 'is-loading is-fullwidth' : ''"
              style="min-height: 54px;">
              <span
                v-if="!mainLoading"
                class="is-size-5">
                {{ totalPrograms }} programme(s)
                <br>
                {{ totalLots }} lot(s)
              </span>
            </div>
          </div>
          <div
            class="is-padding has-background-white"
            v-if="openedCol">
            <div class="field">
              <div class="control">
                <multiselect
                  v-model="statesFilter"
                  @input="updateStatesFilter"
                  name="states"
                  class="multiselect--option-ico"
                  label="label"
                  track-by="value"
                  open-direction="bottom"
                  group-values="states"
                  group-label="region"
                  :group-select="true"
                  :multiple="true"
                  :options="statesByRegion"
                  :searchable="true"
                  :show-labels="false"
                  :close-on-select="false"
                  :placeholder="''"
                  :custom-label="s => `${s.label} - ${s.value}`">
                  <span slot="noResult">Oups! Aucun département trouvé.</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Région et département</span>
                  <span
                    slot="selection"
                    class="multiselect__placeholder"
                    slot-scope="{ values }"
                    v-if="values.length">
                    <span>Région et département ({{ values.length }})</span>
                  </span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
            <div class="field is-padding-bottom">
              <div class="control">
                <div class="field has-addons columns">
                  <div class="control is-expanded column is-8">
                    <multiselect
                      @input="updateSimpleFilter"
                      @search-change="getCityByName"
                      @open="!cityFilter.length ? getCityByName() : null"
                      :loading="loadingFilters === 'ville'"
                      v-model="filters.location"
                      :custom-label="v => `${v.city_code} (${v.zip_code})`"
                      label="v"
                      track-by="pk"
                      class="multiselect--option-ico is-single_choice"
                      open-direction="bottom"
                      :multiple="true"
                      :options="cityFilter"
                      :searchable="true"
                      :close-on-select="false"
                      :show-labels="false"
                      :placeholder="''">
                      <span slot="noResult">Oups! Aucune Ville trouvée.</span>
                      <span
                        slot="placeholder"
                        class="multiselect__placeholder">Ville</span>
                      <!-- <span
                        slot="selection"
                        class="multiselect__placeholder"
                        v-if="filters.location && filters.location.length">
                        <span>Villes ({{ filters.location.length }})</span>
                      </span> -->
                      <span slot="noOptions">La liste est vide</span>
                    </multiselect>
                  </div>
                  <div
                    class="select control is-expanded column is-4"
                    style="height: 100%">
                    <select
                      :disabled="!filterLocation"
                      class="is-size-5"
                      v-model="filters.distance"
                      @change="updateSimpleFilter">
                      <option :value="null">
                        Sélectionner
                      </option>
                      <option
                        v-for="d in DistanceValueList"
                        :key="d.value"
                        :value="d.value">
                        {{ d.value }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="field"
              v-if="isDistributeur">
              <div class="control">
                <multiselect
                  @input="updateSimpleFilter()"
                  @search-change="getPromoteursByName"
                  @open="!promoteursFilter.length ? getPromoteursByName() : null"
                  :loading="loadingFilters === 'promoteur'"
                  v-model="filters.promoteur"
                  label="name"
                  track-by="pk"
                  class="multiselect--option-ico"
                  open-direction="bottom"
                  :multiple="true"
                  :options="promoteursFilter"
                  :searchable="true"
                  :close-on-select="false"
                  :show-labels="false"
                  :placeholder="''">
                  <span slot="noResult">Oups! Aucun promoteur trouvé.</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Promoteur</span>
                  <span
                    slot="selection"
                    class="multiselect__placeholder"
                    slot-scope="{ values }"
                    v-if="values.length">
                    <span>Promoteur ({{ values.length }})</span>
                  </span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <multiselect
                  @input="updateSimpleFilter"
                  @search-change="getProgramsByName"
                  @open="!programsFilter.length ? getProgramsByName() : null"
                  :loading="loadingFilters === 'program'"
                  v-model="filters.program"
                  label="name"
                  track-by="pk"
                  class="multiselect--option-ico"
                  open-direction="bottom"
                  :multiple="true"
                  :options="programsFilter"
                  :searchable="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :show-labels="false"
                  :preserve-search="true"
                  :hide-selected="true"
                  :placeholder="''">
                  <template
                    slot="tag"
                    slot-scope="props">
                    <span></span>
                  </template>
                  <template
                    slot="selection"
                    slot-scope="{ values, isOpen }">
                    <span
                      v-if="values.length && !isOpen"
                      class="multiselect__placeholder">
                      Programmes ({{ values.length }})
                    </span>
                  </template>
                  <template slot="beforeList">
                    <li class="multiselect__element">
                      <span
                        @click="toggleAllPrograms"
                        @mouseenter="hoveredAllPrograms = true"
                        @mouseleave="hoveredAllPrograms = false"
                        class="multiselect__option"
                        :class="{
                          'multiselect__option--selected': filters.program && filters.program.length === programsFilter.length,
                          'multiselect__option--highlight': hoveredAllPrograms
                        }">
                        <span>Tous les programmes</span>
                      </span>
                    </li>
                  </template>
                  <span slot="noResult">Oups! Aucun programme trouvé.</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Programmes</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <multiselect
                  @input="updateSimpleFilter"
                  v-model="filters.operation_type"
                  label="label"
                  track-by="value"
                  class="multiselect--option-ico"
                  open-direction="bottom"
                  :multiple="true"
                  :options="OperationTypeList"
                  :searchable="false"
                  :close-on-select="false"
                  :show-labels="false"
                  :placeholder="''">
                  <span slot="noResult">Oups! Aucun type trouvé.</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Type d'opération</span>
                  <span
                    slot="selection"
                    class="multiselect__placeholder"
                    slot-scope="{ values }"
                    v-if="values.length">
                    <span>Type d'opération ({{ values.length }})</span>
                  </span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
            <div
              v-if="(isAdmin && isPromoteur) || currentUser.active_all_contact"
              class="field">
              <div class="control">
                <multiselect
                  @input="updateSimpleFilter"
                  @open="!programsFilter.length ? getAgenceByName() : null"
                  :loading="loadingFilters === 'agence'"
                  v-model="filters.agence"
                  label="name"
                  track-by="pk"
                  class="multiselect--option-ico is-single_choice"
                  open-direction="bottom"
                  :multiple="true"
                  :options="agencesFilter"
                  :searchable="true"
                  :close-on-select="false"
                  :show-labels="false"
                  :placeholder="''">
                  <span slot="noResult">Oups! Aucune agence trouvée.</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Agences</span>
                  <span
                    slot="selection"
                    class="multiselect__placeholder"
                    slot-scope="{ values }"
                    v-if="values.length">
                    <span>Agences ({{ values.length }})</span>
                  </span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
            <div
              class="field"
              id="actability-filter">
              <div class="control">
                <input
                  id="actability"
                  type="checkbox"
                  name="actability"
                  v-model="actability"
                  @change="updateActabilityFilter()"
                  class="vadCheckradiocase is-primary is-fullwidth"
                  :class="{'is-active' : actability}">
                <label
                  id="actability"
                  class="is-size-6"
                  for="actability">Actable</label>
              </div>
            </div>
            <div class="columns">
              <ModalMultiselect
                v-if="taxDispositifsList && taxDispositifsList.length"
                :opened-modal="openedModal"
                class="column is-6"
                :data-array="taxDispositifsList"
                :selected-array="filters.tax_dispositifs"
                button-width="108"
                modal-width="239"
                position-y="top"
                position-x="left"
                display-name="Dispositifs"
                @open="openedModal = $event"
                @update="updateFilter($event), updateSimpleFilter()" />
              <ModalMultiselect
                v-if="trimestrialsChoicesByYearObj && trimestrialsChoicesByYearObj.length"
                :opened-modal="openedModal"
                class="column is-6"
                :data-array="trimestrialsChoicesByYearObj"
                :selected-array="filters.date_livraison"
                button-width="96"
                modal-width="112"
                position-y="top"
                display-name="Livraison"
                @open="openedModal = $event"
                @update="updateFilter($event), updateSimpleFilter()" />
            </div>
            <ModalMultiselect
              v-if="naturesList && naturesList.length"
              :opened-modal="openedModal"
              :data-array="naturesList"
              :selected-array="filters.nature"
              button-width="108"
              modal-width="239"
              display-name="Nature du bien"
              @open="openedModal = $event"
              @update="updateFilter($event), updateSimpleFilter()" />
          </div>
          <div slot="criteria">
            <div class="is-margin-bottom-xsmall">
              <r-label
                :label="'Surface (m²)'"
                :is-required="false"
                class="has-text-grey"></r-label>
              <div class="field has-addons columns">
                <p class="control is-expanded column is-6">
                  <v-input
                    id="surface_min"
                    :name="'surface_min'"
                    @input="val => { filters.surface__gte = val; updateSimpleFilter() }"
                    :model="filters.surface__gte"
                    :number="true"
                    input-type="number"
                    :three-space="true"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as=" "
                    :placeholder="'Min'">
                  </v-input>
                </p>
                <p class="control is-expanded column is-6">
                  <v-input
                    id="surface_max"
                    :name="'surface_max'"
                    @input="val => { filters.surface__lte = val; updateSimpleFilter() }"
                    :model="filters.surface__lte"
                    :number="true"
                    :three-space="true"
                    input-type="number"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as=" "
                    :placeholder="'Max'">
                  </v-input>
                </p>
              </div>
            </div>
            <div class="is-margin-bottom-xsmall">
              <r-label
                :label="'Budget (€)'"
                :is-required="false"
                class="has-text-grey"></r-label>
              <div class="field has-addons columns">
                <p class="control is-expanded column is-6">
                  <v-input
                    id="sale_price_min"
                    :name="'sale_price_min'"
                    @input="val => { filters.sale_price_ttc__gte = val ; updateSimpleFilter() }"
                    :model="filters.sale_price_ttc__gte"
                    :number="true"
                    :three-space="true"
                    input-type="number"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as=" "
                    :placeholder="'Min'">
                  </v-input>
                </p>
                <p class="control is-expanded column is-6">
                  <v-input
                    id="sale_price_max"
                    :name="'sale_price_max'"
                    @input="val => { filters.sale_price_ttc__lte = val ; updateSimpleFilter() }"
                    :model="filters.sale_price_ttc__lte"
                    :number="true"
                    :three-space="true"
                    input-type="number"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as=" "
                    :placeholder="'Max'">
                  </v-input>
                </p>
              </div>
            </div>
            <ModalMultiselect
              v-if="filteredTypesList && filteredTypesList.length"
              :opened-modal="openedModal"
              :data-array="filteredTypesList"
              :selected-array="filters.lot_type"
              button-width="108"
              modal-width="239"
              display-name="Type du bien"
              @open="openedModal = $event"
              @update="updateFilter($event), updateSimpleFilter()" />
          </div>

          <div slot="more-criteria">
            <ModalMultiselect
              v-if="filteredSubtypesList && filteredSubtypesList.length"
              :opened-modal="openedModal"
              :data-array="filteredSubtypesList"
              :selected-array="filters.lot_subtype"
              button-width="108"
              modal-width="239"
              display-name="Caractéristique du bien"
              @open="openedModal = $event"
              @update="updateFilter($event), updateSimpleFilter()" />
            <ModalMultiselect
              v-if="annexesList && annexesList.length"
              :opened-modal="openedModal"
              :data-array="annexesList"
              :selected-array="filters.annex_type"
              button-width="108"
              modal-width="239"
              display-name="Annexes"
              @open="openedModal = $event"
              @update="updateFilter($event), updateSimpleFilter()" />
            <div
              class="columns">
            </div>
            <div class="columns is-multiline">
              <ModalMultiselect
                v-if="exposureList && exposureList.length"
                :opened-modal="openedModal"
                class="column is-6 is-marginless"
                :data-array="exposureList"
                :selected-array="filters.exposures"
                button-width="96"
                modal-width="112"
                display-name="Orientation"
                @open="openedModal = $event"
                @update="updateFilter($event), updateSimpleFilter()" />
              <ModalMultiselect
                v-if="filteredFloorsList && filteredFloorsList.length"
                :opened-modal="openedModal"
                class="column is-6 is-marginless"
                :data-array="filteredFloorsList"
                :selected-array="filters.floor"
                button-width="96"
                modal-width="112"
                display-name="Étage"
                @open="openedModal = $event"
                @update="updateFilter($event), updateSimpleFilter()" />
              <ModalMultiselect
                v-if="salesmodeList && salesmodeList.length"
                :opened-modal="openedModal"
                class="column is-6 is-marginless"
                :data-array="salesmodeList"
                :selected-array="filters.sales_mode"
                button-width="96"
                modal-width="112"
                display-name="Mode vente"
                @open="openedModal = $event"
                @update="updateFilter($event), updateSimpleFilter()" />
              <ModalMultiselect
                v-if="filters.nature.includes('field')"
                :opened-modal="openedModal"
                class="column is-6 is-marginless"
                :data-array="nbfaceList"
                :selected-array="filters.nb_face"
                button-width="96"
                modal-width="112"
                display-name="Nb de faces"
                @open="openedModal = $event"
                @update="updateFilter($event), updateSimpleFilter()" />
            </div>
          </div>
        </col-collapse-filter>
      </template>
      <div class="is-border_X">
        <spinner-round
          :is-loading="mainLoading"
          v-if="mainLoading"></spinner-round>
        <div v-else>
          <list-top-bar
            :has-filtered="hasFilter"
            :display-result="false"
            :is-conditioned="true"
            :total-lots-child="totalLots"
            :total-programs-child="totalPrograms"
            :child-action-group="parentActionGroup"
            :display-filter-admin="true"
            @update:childActionGroup="handleActionGroupUpdate"
            @update:localfilteredAdmin="handleAdminFiltersOpened"
            @startBigExport="ExportAllLot">
          </list-top-bar>
          <div
            class="is-border-left is-border-right is-border-bottom has-background-white"
            v-if="adminFiltersOpened">
            <div class="is-padding">
              <div
                class="columns">
                <div class="column is-4 columns is-column is-gapless is-space-between is-marginless">
                  <r-label
                    label="Lots visibles vendeur(s) interne"
                    :is-required="false"></r-label>
                  <div class="control">
                    <div class="select">
                      <select
                        v-model="filters.lot__intern_visibility"
                        @change="updateSimpleFilter">
                        <option :value="undefined">
                          Tous
                        </option>
                        <option :value="1">
                          Visible
                        </option>
                        <option :value="0">
                          Non visible
                        </option>
                      </select>
                    </div>
                  </div>
                  <!-- <div class="control">
                    <input
                      id="intern_visibility"
                      name="intern_visibility"
                      type="checkbox"
                      class="switch is-success is-rounded"
                      v-model="filters.intern_visibility"
                      @change="updateSimpleFilter">
                    <label
                      for="intern_visibility"
                      class="is-uppercase">
                      <span
                        v-if="internVisible"
                        class="is-size-6 is-margin-top-xxsmall">Lots visibles vendeur(s) interne
                      </span>
                      <span
                        v-else
                        class="is-size-6 is-margin-top-xxsmall">Lots masqués vendeur(s) interne
                      </span>
                    </label>
                  </div> -->
                </div>
                <div class="column is-4 columns is-column is-gapless is-space-between is-marginless">
                  <r-label
                    label="Lots visibles prescripteur(s)"
                    :is-required="false"></r-label>
                  <div class="control">
                    <div class="select">
                      <select
                        v-model="filters.lot__extern_visibility"
                        @change="updateSimpleFilter">
                        <option :value="undefined">
                          Tous
                        </option>
                        <option :value="1">
                          Visible
                        </option>
                        <option :value="0">
                          Non visible
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <!-- <div class="column is-4 columns is-column is-gapless is-space-between is-marginless">
                  <div class="control">
                    <input
                      id="extern_visibility"
                      name="extern_visibility"
                      type="checkbox"
                      class="switch is-success is-rounded"
                      v-model="filters.extern_visibility"
                      @change="updateSimpleFilter">
                    <label
                      for="extern_visibility"
                      class="is-uppercase">
                      <span
                        v-if="externVisible"
                        class="is-size-6 is-margin-top-xxsmall">Lots visibles prescripteur(s)
                      </span>
                      <span
                        v-else
                        class="is-size-6 is-margin-top-xxsmall">Lots masqués prescripteur(s)
                      </span>
                    </label>
                  </div>
                </div> -->
              </div>
              <r-label
                label="Statut du lot"
                :is-required="false"></r-label>
              <div class="columns is-multiline is-padding-top-xsmall is-padding-bottom-xsmall is-padding-left-xsmall">
                <div
                  class="control column is-narrow is-paddingless"
                  v-for="p in profilAvailableStatus"
                  :key="p.value">
                  <input
                    class="is-checkradio is-squareCheck"
                    :id="'lot-' + p.value"
                    type="checkbox"
                    :name="'lot-' + p.value"
                    :value="p.value"
                    v-model="filters.lot__status"
                    @change="updateSimpleFilter">
                  <label :for="'lot-' + p.value">{{ p.label }}</label>
                </div>
              </div>
            </div>
            <div class="is-border-top is-border--dashed is-padding">
              <r-label
                label="Statut du programme"
                :is-required="false"></r-label>
              <div class="columns is-multiline is-padding-top-xsmall is-padding-bottom-xsmall is-padding-left-xsmall">
                <div
                  class="control column is-narrow is-paddingless"
                  v-for="s in workflowStatusList"
                  :key="s.value">
                  <input
                    class="is-checkradio is-squareCheck"
                    :id="'programme-' + s.value"
                    type="checkbox"
                    :name="'programme-' + s.value"
                    :value="s.value"
                    v-model="filters.program__status"
                    @change="updateSimpleFilter">
                  <label :for="'programme-' + s.value">{{ s.label }}</label>
                </div>
              </div>
            </div>
            <div
              v-if="!currentUser.active_all_contact"
              class="is-border-top is-border--dashed columns is-gapless">
              <div
                v-if="mgcEnabled"
                class="column is-4 is-border-right is-border--dashed is-padding-top-xsmall is-padding-bottom is-padding-left-large">
                <r-label
                  label="Multi-diffusion"
                  :is-required="false"></r-label>
                <div class="control">
                  <div class="select">
                    <select
                      v-model="filters.diffusion_enabled"
                      @change="updateSimpleFilter">
                      <option :value="undefined">
                        Etat de la publication
                      </option>
                      <option :value="1">
                        Activée
                      </option>
                      <option :value="0">
                        Désactivée
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div
                class="column is-4 is-border-right is-border--dashed is-padding-top-xsmall is-padding-bottom is-padding-left-large">
                <r-label
                  label="Mini-site"
                  :is-required="false"></r-label>
                <div class="control">
                  <div class="select">
                    <select
                      v-model="filters.site_enabled"
                      @change="updateSimpleFilter">
                      <option :value="undefined">
                        Etat de la publication
                      </option>
                      <option :value="1">
                        Activée
                      </option>
                      <option :value="0">
                        Désactivée
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="column is-4 is-padding-top-xsmall is-padding-bottom is-padding-left-large">
                <date-picker
                  :model="{created_on__gte: filters.created_on__gte, created_on__lte: filters.created_on__lte}"
                  :is-range="true"
                  :is-filter="true"
                  :style-version="2"
                  :config="{mode: 'range'}"
                  label="Date de création"
                  @input="Object.assign(filters, $event); updateSimpleFilter()"></date-picker>
              </div>
            </div>
          </div>
          <spinner-round
            :is-loading="loading"
            v-if="loading"></spinner-round>
          <div
            v-else
            :style="($route.name === 'ProgramCardList' || $route.name === 'ProgramList') && isMultiselect ? 'justify-content: flex-end' : 'justify-content: space-between'"
            class="field is-grouped has-background-white is-border-left is-border-right"
            :class="isMultiselect ? 'is-border-bottom' : ''">
            <div
              style="padding: 1.3rem ; overflow-x: auto !important"
              class="is-flex is-padding-less is-nowrap is-border-bottom"
              v-if="$route.name === 'LotList'">
              <p class="control">
                <label
                  :for="'statusLotFilterStockVue-' + p.value"
                  v-for="p in profilAvailableStatus"
                  :key="p.value"
                  class="checkbox checkRadioIsHide is-margin-right-xsmall"
                  :id="'statusLot-' + p.value">
                  <input
                    type="checkbox"
                    :id="'statusLotFilterStockVue-' + p.value"
                    v-model="filters.lot__status"
                    :value="p.value"
                    :name="'statusLot-' + p.value"
                    @change="updateSimpleFilter()">
                  <span
                    class="tag"
                    :class="'is-' + p.value">
                    <span>{{ p.label }}</span>
                    <span class="icon">
                      <i
                        class="far"
                        :class="filters.lot__status && filters.lot__status.includes(p.value) ? 'fa-check-square' : 'fa-square'"></i>
                    </span>
                  </span>
                </label>
              </p>
            </div>
            <div
              style="flex-shrink: 0; align-items: stretch"
              class="is-flex is-nowrap">
              <div
                v-if="isAdmin && isPromoteur && isMultiselect && parentActionGroup"
                class="column is-narrow is-paddingless is-border-left container-btn-export-stock">
                <a
                  @click="selectedItems.length ? ($route.name === 'LotList' ? changeLotsStatusSelection() : changeProgramsStatusSelection()) : ''"
                  :style="selectedItems.length ? 'background-color: #8dbb7d; color: white; cursor: pointer' : 'cursor: default; color: #D7D7D7'"
                  class="btn-export_stock is-uppercase">
                  <span class="icon">
                    <i class="fas fa-exchange-alt"></i>
                  </span>
                  <span>Changer Statut</span>
                </a>
              </div>
              <div
                v-if="isAdmin && isPromoteur && isMultiselect && parentActionGroup || isPromoteur && currentUser.active_all_contact && isMultiselect && parentActionGroup"
                class="column is-narrow is-paddingless is-border-left container-btn-export-stock">
                <a
                  @click="checkSelected()"
                  :style="selectedItems.length ? 'background-color: #8dbb7d; color: white; cursor: pointer' : 'cursor: default; color: #D7D7D7'"
                  class="btn-export_stock is-uppercase">
                  <span class="icon"><i class="fas fa-file-excel"></i></span><span>Exporter Excel</span>
                </a>
              </div>
            </div>
          </div>
          <filters-tags
            class="is-border-left is-border-right"
            :has-filter="hasFilter"
            :filters="filters"
            :ignore-tags="['lot__status', 'extern_visibility', 'intern_visibility', 'contact_search_area']"
            @reset="resetFilters"
            @update="(v, key) => deleteFiltersFromTags(v, key)">
          </filters-tags>
          <div v-if="['ProgramList', 'ProgramCardList'].includes($route.name) && programs && programs.length">
            <div class="columns is-gapless is-padding-left is-padding-right is-vcentered has-background-white is-marginless is-border-left is-border-right">
              <div class="column is-narrow">
                <div class="is-padding-top-small is-padding-bottom-small">
                  <div>
                    <input
                      id="changeStockPgmPanelTable"
                      name="changeStockPgmPanelTable"
                      type="checkbox"
                      class="switch is-success is-rounded"
                      v-model="displayProgramCardList"
                      @change="toggleProgramCardList">
                    <label for="changeStockPgmPanelTable">Affichage des données en tableau</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <router-view
            :key="$route.name"
            :source-programs="programs"
            :source-lots="lots"
            :loading="mainLoading"
            :source-sort-by="sortBy"
            @updateSources="updateSources"
            @sort="sort"
            @reload="getStock"
            @deleteElementInList="deleteElementInList"></router-view>
          <div v-show="!loading && !programs.length && $route.name !== 'LotList'">
            <div class="is-padding-small">
              <h2 class="title is-3 has-text-weight-bold">
                Aucun programme à afficher
              </h2>
              <a
                class="has-text-primary"
                @click="resetFilters"
                v-if="hasFilter"><span class="icon"><i
                  class="fas fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
            </div>
          </div>
          <div v-show="!loading && !lots.length && $route.name === 'LotList'">
            <div class="is-padding">
              <a
                class="has-text-primary"
                @click="resetFilters"
                v-if="hasFilter"><span class="icon"><i
                  class="fas fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
            </div>
          </div>
          <pagination
            :loading="mainLoading"
            :current-page="currentPageStock"
            :total-page="totalPageStock"
            @changePage="loadItems($event)"></pagination>
        </div>
      </div>
    </page-content>
  </div>
</template>

<script>
import { cloneDeep, isEmpty } from 'lodash'
import { mapGetters, mapState } from 'vuex'
import { bus, EVENTS } from '@/bus'
import { FilterGetter, Multiselection, Sort } from '@/mixins'
import StockMixin from './StockMixin'
import StockFiltersMixin from './StockFiltersMixin'
import ModalMultiselect from '../utils/form/ModalMultiselect.vue'
import UploadMixin from '../../mixins/UploadMixin'

export default {
  name: 'StockVue',
  components: [ ModalMultiselect ],
  mixins: [
    StockMixin,
    StockFiltersMixin,
    FilterGetter,
    Sort,
    Multiselection,
    UploadMixin
  ],
  data () {
    return {
      hoveredAllPrograms: false,
      filteredFloorsList: [],
      openedModal: '',
      isParent: true,
      openedCol: true,
      adminFiltersOpened: false,
      // switch between normal list and card list vue
      displayProgramCardList: false,
      displaySort: false,
      loadDocuments: this.loadItems,
      query: {
        sort: 'ref:asc'
      },
      hideTopButtom: true,
      bigExport: false,
      importLoading: false,
      filtersSelected: null,
      dataForExport: [],
      parentActionGroup: false,
      // data par default seulement pour stock / pas pour adv
      filters: {
        distance: 1
      },
      initFilters: {
        distance: 1
      }
    }
  },
  computed: {
    ...mapState(['savedFilters']),
    ...mapGetters(['isDistributeur', 'isPromoteur', 'isManager']),
    arrayKey () {
      if (this.$route.name === 'LotList') return 'lots'
      else return 'programs'
    },
    filteredTypesList () {
      // return this.typesList
      return this.typesList.filter((x) => this.filters.nature.some(r => x.show.includes(r)))
    },
    filteredSubtypesList () {
      // return this.subtypesList
      return this.subtypesList.filter((x) => this.filters.nature.some(r => x.show.includes(r)))
    },
    internVisible () {
      return this.filters.intern_visibility
    },
    externVisible () {
      return this.filters.extern_visibility
    },
    isMultiselect () {
      return this.multiselection
    },
    filterLocation () {
      if (Array.isArray(this.filters.location) && this.filters.location.length > 0) {
        return true
      }
      return false
    }
  },
  watch: {
    '$route.name' (v) {
      this.cancelSelect()
      if (v === 'StockVue') this.$router.replace({ name: 'ProgramCardList' }).catch(() => {})
      // this.filters.page = 1
      this.toggleDatas()
    },
    'filters.nature' (to) {
      // delete type if nature is not selected
      let enabledTypes = this.typesList.filter((x) => to.some(r => x.show.includes(r))).map(x => x.value)
      this.filters.lot_type = this.filters.lot_type.filter(type => enabledTypes.includes(type))
      // delete subtype if nature is not selected
      let enabledSubtypes = this.subtypesList.filter((x) => to.some(r => x.show.includes(r))).map(x => x.value)
      this.filters.lot_subtype = this.filters.lot_subtype.filter(subtype => enabledSubtypes.includes(subtype))
      // delete nb face if nature is not selected
      if (!to.includes('field')) {
        this.filters.nb_face = []
        this.filters.sales_mode = []
      }
      // conditionning display floor button
      if (['flat', 'house', 'commercial', 'office', 'annexe', 'bedroom'].some(x => to.some(nature => x === nature))) {
        this.filteredFloorsList = this.floorsList
      } else {
        this.filteredFloorsList = []
        this.filters.floor = []
      }
    }
  },
  async created () {
    this.cancelSelect()
    if (!isEmpty(this.$route.params) && this.$route.params.destination) {
      await this.initFiltersParams()
    } else if (!isEmpty(this.$route.query)) {
      await this.initQueryParams()
    } else if ('stockList' in this.savedFilters) {
      this.loadOnCreate = false
      this.initSavedFilters()
    } else {
      await this.initQueryParams()
    }
    this.toggleDatas()
    this.filtersSelected = await this.beforeSubmit()
    // this.getAllPk()
  },
  async mounted () {
    // listen scroll event to display or not result fake button
    document.addEventListener('scroll', this.displayTopButton, true)

    if (this.openedCol === false && window.innerWidth <= 1280) {
      this.openedCol = !this.openedCol
      bus.$emit(EVENTS.RESIZE_TABLE)
    }
  },
  destroyed () {
    document.removeEventListener('scroll', this.displayTopButton, true)
  },
  methods: {
    updateFilter ({ filter, array }) {
      if (!array) return
      // check if filter is date_livraison
      if (Array.isArray(filter.value)) {
        filter.value.forEach(year => {
          let i = array.findIndex(x => x === year)
          if (i >= 0) array.splice(i, 1)
          else array.push(year)
        })
      } else {
        let i = array.findIndex(x => x === filter.value)
        if (i >= 0) array.splice(i, 1)
        else array.push(filter.value)
      }
    },
    initSavedFilters () {
      this.filters = cloneDeep(this.savedFilters.stockList)
      this.updateSimpleFilter()
    },
    /**
       * toggle Boolean displayProgramCardList
       * change data of items pks for multiselect
       */
    toggleDatas () {
      if (this.$route.name === 'ProgramList') {
        this.$store.commit('setMultiselectionItemsPksAvailable', this.programs)
        this.displayProgramCardList = true
      } else if (this.$route.name === 'ProgramCardList') {
        this.$store.commit('setMultiselectionItemsPksAvailable', this.programs)
        this.displayProgramCardList = false
      } else {
        this.$store.commit('setMultiselectionItemsPksAvailable', this.lots)
        this.displayProgramCardList = false
      }
    },
    /**
       * default assignation for page, count, etc
       */
    initLots (data) {
      this.lots = data.items
      this.totalLots = data.count
      this.totalPageLots = data.pages
      this.currentPageLots = data.page
      this.toggleDatas()
    },
    /**
       * default assignation for page, count, etc
       */
    initPrograms (data) {
      this.programs = data.items
      this.totalPrograms = data.count
      this.totalPagePrograms = data.pages
      this.currentPagePrograms = data.page
      this.toggleDatas()
    },
    /**
       * Otherwrite GenericListMixin loaditem and call main stock getter
       * @param { Number } page - for pagination call
       */
    loadItems (page = null) {
      this.getStock(page)
    },
    /**
       * Déclenche l'import du stock SPO en arrière-plan pour le compte connecté.
       * L'import tourne côté worker (peut prendre quelques minutes) -> on invite à rafraîchir.
       */
    async triggerSpoImport () {
      if (this.importLoading) return
      this.importLoading = true
      try {
        await this.$api.axios.post('spo/import', {})
        this.$toasted.global.success('Import SPO lancé. Rafraîchissez la page dans quelques minutes.')
      } catch (e) {
        console.log(e)
        const msg = e.response && e.response.data && e.response.data.error ? e.response.data.error : 'Erreur lors de l\'import SPO !'
        this.$toasted.global.danger(msg)
      } finally {
        this.importLoading = false
      }
    },
    /**
       * Main getter for Stock - call lots getter and programs getters
       * @param { Number } page - for pagination call
       */
    async getStock (page) {
      const filters = await this.beforeSubmit()
      filters.per_page = 50
      this.getPrograms(filters, page)
      await this.getLots(filters, page)
      this.$store.dispatch('scrollToLastEl')
    },
    /**
       * Get Lots for Stock
       * @param { Object } filters
       * @param { Number } page
       */
    async getLots (filters = {}, page) {
      let params = Object.assign({ per_page: 200 }, filters, this.query)
      if (page && this.$route.name === 'LotList') params.page = page
      // if (params.sort && this.$route.name !== 'ProgramList') return
      this.lotLoading = true
      try {
        let { data } = await this.$api.get(this.$resources.STOCK_LOT, params)
        this.initLots(data)
        this.lotLoading = false
      } catch (e) {
        console.log(e)
        this.lotLoading = false
        this.$toasted.global.danger('Erreur lors de la récupération des lots !')
      }
    },
    /**
       * Get program for Stock
       * @param { Object } filters
       * @param { Number } page
       */
    async getPrograms (filters = {}, page) {
      let params = Object.assign({}, filters, this.query)
      if (page && this.$route.name !== 'LotList') params.page = page
      // if (params.sort && this.$route.name === 'LotList') return
      this.programLoading = true
      try {
        let { data } = await this.$api.get(this.$resources.STOCK_PROGRAM, params)
        this.initPrograms(data)
        this.programLoading = false
      } catch (e) {
        console.log(e)
        this.programLoading = false
        this.$toasted.global.danger('Erreur lors de la récupération des programmes !')
      }
    },
    toggleProgramCardList () {
      if (this.$route.name === 'ProgramList') {
        this.$router.replace({ name: 'ProgramCardList' }).catch(() => {})
      } else {
        this.$router.replace({ name: 'ProgramList' }).catch(() => {})
      }
    },
    openCollapseFilter () {
      this.openedCol = !this.openedCol
      this.hideTopButtom = this.openedCol
    },
    /**
       * Display buttin with result in top navbar when close filters panel or scroll in filters panel
       */
    displayTopButton () {
      if (['ProgramList', 'ProgramCardList', 'LotList', 'StockMap'].includes(this.$route.name)) {
        let divScrollTop = document.querySelector('#pageContent') ? document.querySelector('#pageContent').offsetTop : null
        let filterInfo = document.querySelector('#filter-info') ? document.querySelector('#filter-info').getBoundingClientRect() : null
        if (this.openedCol && filterInfo) {
          if (divScrollTop > (filterInfo.bottom - divScrollTop)) this.hideTopButtom = false
          else this.hideTopButtom = true
        }
      }
    },
    deleteElementInList (id) {
      let list = 'programs'
      if (this.$route.name === 'LotList') list = 'lots'
      let idx = this[list].findIndex(x => x.pk === id)
      if (idx >= 0) {
        this[list].splice(idx, 1)
      }
    },
    async ExportAllLot () {
      const filters = await this.beforeSubmit()
      this.lotLoading = true
      try {
        let keysToRemove = []
        for (let key in filters) {
          if (filters[key] === null || (Array.isArray(filters[key]) && filters[key].length === 0)) {
            keysToRemove.push(key)
          }
        }
        keysToRemove.forEach(key => delete filters[key])
        let params = {
          filters: filters,
          account: this.currentUser.account.pk
        }
        if (this.$route.name === 'LotList' && this.lots.length < 50) {
          this.exportXlsFromMultiselect('LOT', 'liste-lots', null, params)
        } else if (this.$route.name === 'ProgramCardList') {
          this.exportXlsFromMultiselect('PROGRAM', 'liste-programmes', null, params)
        } else {
          this.sendExport()
          this.$toasted.global.success('Vous allez recevoir une notification quand votre fichier sera prêt')
        }
        this.lotLoading = false
      } catch (e) {
        console.log(e)
        this.lotLoading = false
        this.$toasted.global.danger('Erreur lors de la récupération des stocks !')
      }
    },
    async sendExport () {
      const filters = await this.beforeSubmit()
      let documentName
      let service
      let keysToRemove = []
      for (let key in filters) {
        if (filters[key] === null || (Array.isArray(filters[key]) && filters[key].length === 0)) {
          keysToRemove.push(key)
        }
      }
      keysToRemove.forEach(key => delete filters[key])
      let params = {
        filters: filters,
        account: this.currentUser.account.pk
      }
      if (this.$route.name === 'LotList') {
        service = 'LOT'
        documentName = 'liste des lots'
        await this.downloadDocuments(this.dataForExport, documentName, service, params)
      } else {
        service = 'PROGRAM'
        documentName = 'liste des programmes'
        await this.downloadDocuments(this.dataForExport, documentName, service, params)
      }
    },
    cancelSelect () {
      this.parentActionGroup = false
      this.$store.commit('cancelMultiselection')
    },
    handleActionGroupUpdate (newValue) {
      this.parentActionGroup = newValue
    },
    handleAdminFiltersOpened (newValue) {
      this.adminFiltersOpened = newValue
    },
    checkSelected () {
      if (this.selectedItems.length) {
        if (this.$route.name === 'LotList') {
          this.exportXlsFromMultiselect('LOT', 'liste-lots')
        } else {
          this.exportXlsFromMultiselect('PROGRAM', 'liste-programmes')
        }
        this.cancelSelect()
      }
    },
    toggleAllPrograms () {
      if (this.filters.program && this.filters.program.length === this.programsFilter.length) {
        // Si tous les programmes sont déjà sélectionnés, les désélectionner tous
        this.filters.program = []
      } else {
        // console.log('this.programsFilter.length :', this.programsFilter.length)
        // console.log('this.filters.program.length :', this.filters.program.length)
        // Ajouter tous les programmes à la sélection existante (sans doublons)
        const currentSelection = this.filters.program || []
        const allPrograms = [...this.programsFilter]
        // Fusionner les deux listes en évitant les doublons
        const merged = [...currentSelection]
        allPrograms.forEach(program => {
          if (!merged.find(p => p.pk === program.pk)) {
            merged.push(program)
          }
        })
        this.filters.program = merged
      }
      this.updateSimpleFilter()
    }
  }
}
</script>

<style lang="sass">
.outside_multiselectmodal
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: #FFFFFF
  opacity: 0.7
  z-index: 10

.container-btn-export-stock
  width: 217px
  min-height: 50px
  flex: 0 0 auto

.btn-export_stock
  background-color: #fff
  color: #7a7a7a
  width: 100%
  min-height: 100%
  font-size: 1.2rem
  display: flex
  align-items: center
  justify-content: center

.multiselect--option-ico .multiselect__content-wrapper
  min-width: 500px
  width: auto

</style>
